import type { EditConfigCustomIcons } from '@types';

export const customIconDefaultMap: Record<keyof EditConfigCustomIcons, string> =
  {
    shareBtn: '/imgs/share.0cfb73073e6373caf5832e968f0734d2.png',
    likeBtn: '/imgs/like.a062dd954f8a772a798d4c53d676c9fe.png',
    likeBtnActive: '/imgs/like-a.3dbf5e9179d913b0e2347d4634b49c7a.png',
    commentBtn: '/imgs/comment.11cf0c7b2bc225875a2ed4a96004937b.png',
    remarkBtn: '/imgs/remark.9eea3e8b2e8f15a8402085c0a12e3bda.png',
  };

export const customIconLegacyDefaultMap: Record<
  keyof EditConfigCustomIcons,
  string
> = {
  shareBtn: '/imgs/share.5e2c7c7442285250c2860b70c5911599.png',
  likeBtn: '/imgs/like.7ecb98324fc1bc0ad7372cab912b025f.png',
  likeBtnActive: '/imgs/linked.02299cd0054fad8c3d60465e84fb65c0.png',
  commentBtn: '/imgs/comment.a306f4106458883e60215fd121cb7afa.png',
  remarkBtn: '/imgs/intro.81934668c7e3e228f6e6c1b52352c621.png',
};
